module.exports = __webpack_public_path__ + "static/media/climbing_view_1600.e03bd5ca.jpg";